// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Content__Wrapper_3RJVI container","Block":"Content__Block_1RZGn","ColLeft":"Content__ColLeft_QvDUN"};